import { Route } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ProductComponent } from './product/product.component';
import { CartComponent } from './cart/cart.component';

export const appRoutes: Route[] = [
  { path: '', component: HomeComponent },
  { path: 'product/:sku', component: ProductComponent },
  { path: 'cart', component: CartComponent },
  { path: '**', redirectTo: '' },
];
